import { render, staticRenderFns } from "./ModalsContainer.vue?vue&type=template&id=67e3a2e2&"
import script from "./ModalsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports